import React from "react";
import Lottie from "react-lottie";
import NotFoundLottie from "../lotties/404.json";

export default function NotFound() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: NotFoundLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="mt-24 mb-2 px-16 flex-grow flex flex-row">
      <div className="flex-1 flex items-center justify-center">
        <div>
          <Lottie options={defaultOptions} />
        </div>
      </div>
    </div>
  );
}
